import { IntercomArticle } from '@app/services/intercom/content';
import { SupportButton } from '@shared/components/buttons/support-button';
import Text from '@shared/components/content/text';
import { Button } from '@shared/components/ui/button';
import { ReactNode } from 'react';

interface EmptyPageContentProps {
  title?: string;
  description: string | ReactNode;
  primaryAction?: () => void;
  primaryActionText?: string;
  /** Optional leading icon for the primary action button. */
  primaryActionIcon?: ReactNode;
  primaryActionTestId?: string;
  secondaryAction?: () => void;
  secondaryActionText?: string;
  supportArticle?: IntercomArticle;
}

export default function EmptyPageContent({
  title,
  description,
  primaryAction,
  primaryActionText,
  primaryActionIcon,
  primaryActionTestId,
  supportArticle,
  secondaryAction,
  secondaryActionText,
}: EmptyPageContentProps) {
  return (
    <div className="mb-32 flex flex-1 items-center justify-center pt-12">
      <div className="flex items-center justify-center">
        <div className="flex max-w-lg flex-col items-center space-y-8">
          {title && <Text variant="section">{title}</Text>}
          {typeof description === 'string' ? (
            <Text className="text-center">{description}</Text>
          ) : (
            description
          )}
          {/* Wraps to a vertical stack when the actions don't fit on one row. */}
          <div className="flex flex-wrap items-center justify-center gap-4">
            {supportArticle && (
              <SupportButton article={supportArticle} size="lg" />
            )}
            {primaryAction && primaryActionText && (
              <Button
                type="button"
                size="lg"
                onClick={primaryAction}
                data-testid={primaryActionTestId}
                icon={primaryActionIcon}
              >
                {primaryActionText}
              </Button>
            )}
            {secondaryAction && secondaryActionText && (
              <Button
                variant="secondary"
                type="button"
                size="lg"
                onClick={secondaryAction}
              >
                {secondaryActionText}
              </Button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
